import { emailAddressValidator, telephoneNumberValidator } from '../../../../';
import { fieldNames } from '../InformationContactForm.config';
import {
  InformationContactFormProps,
  FieldNamesType,
} from '../InformationContactForm.types';

const contactFieldsToCheck = [
  fieldNames.EMAIL_ADDRESS,
  fieldNames.PHONE_NUMBER,
];

interface ErrorType {
  required?: boolean;
  format?: boolean;
  unsupportedCharacters?: boolean;
  houseNumber?: boolean;
  invalidRegion?: boolean;
  message?: string;
}

interface ErrorsType {
  [key: FieldNamesType]: ErrorType;
}

/**
 * Returns errors as an object of fieldNames as keys and flags to return error types
 */
export function validateInformationContactFormFields(
  values: InformationContactFormProps['values'],
  requiredFields: InformationContactFormProps['requiredFields'] = contactFieldsToCheck,
) {
  const errors: ErrorsType = {};

  const pushFieldError = (fieldName: FieldNamesType, errorObj: ErrorType) => {
    errors[fieldName] = {
      ...(errors[fieldName] || {}),
      ...(errorObj || {}),
    };
  };

  Object.entries(values).forEach(([fieldName, value]) => {
    if (requiredFields.includes(fieldName) && !value?.length) {
      pushFieldError(fieldName, { required: true });
    }
    if (
      fieldName === fieldNames.EMAIL_ADDRESS &&
      !emailAddressValidator(values.emailAddress)
    ) {
      pushFieldError(fieldName, { format: true });
    }
    if (
      fieldName === fieldNames.PHONE_NUMBER &&
      !telephoneNumberValidator(values.telephoneNumber)
    ) {
      pushFieldError(fieldName, { format: true });
    }
  });

  return errors;
}
